import React, { useState, useEffect, useRef } from 'react';
import './ResizableDivider.css';

export default function ResizableDivider({ onResize, minWidth = 300, maxWidth = 800 }) {
  const [isDragging, setIsDragging] = useState(false);
  const dividerRef = useRef(null);

  useEffect(() => {
    if (isDragging) {
      const handleMouseMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newWidth = Math.min(Math.max(e.clientX, minWidth), maxWidth);
        localStorage.setItem('leftPanelWidth', newWidth.toString());
        if (onResize) {
          onResize(newWidth);
        }
      };

      const handleMouseUp = (e) => {
        e.preventDefault();
        setIsDragging(false);
      };

      // Use capture phase to ensure we catch the events
      document.addEventListener('mousemove', handleMouseMove, true);
      document.addEventListener('mouseup', handleMouseUp, true);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';

      return () => {
        document.removeEventListener('mousemove', handleMouseMove, true);
        document.removeEventListener('mouseup', handleMouseUp, true);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };
    }
  }, [isDragging, minWidth, maxWidth, onResize]);

  return (
    <div
      ref={dividerRef}
      className={`resizable-divider ${isDragging ? 'dragging' : ''}`}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
      }}
      style={{ pointerEvents: 'auto' }}
    >
      <div className="divider-handle" />
    </div>
  );
}

